// remove key from object and return new object
export function removeKey(obj: any = {}, key: string) {
  if (!obj[key]) {
    return obj
  }
  const { [key]: deletedKey, ...otherKeys } = obj
  return otherKeys
}

// remove an array of keys from object and return new object
export function removeKeys(obj: any = {}, keys: string[]) {
  return keys.reduce((acc, key) => removeKey(acc, key), obj)
}

function isPlainObject(x: unknown) {
  return Object.prototype.toString.call(x) === "[object Object]"
}

export function deepEquals(x: unknown, y: unknown): boolean {
  if (x === y) {
    return true
  } else if (typeof x !== typeof y) {
    return false
  } else if (Array.isArray(x) || Array.isArray(y)) {
    const xIsArray = Array.isArray(x)
    const yIsArray = Array.isArray(y)
    if (!(xIsArray && yIsArray)) {
      return false
    } else if (x.length !== y.length) {
      return false
    } else {
      return x.every((el, i) => deepEquals(el, y[i]))
    }
  } else if (isPlainObject(x)) {
    // They must both be objects
    const xKeys = Object.keys(x as any).sort()
    const yKeys = Object.keys(y as any).sort()

    if (xKeys.length !== yKeys.length) {
      return false
    } else if (!xKeys.every((el, i) => el === yKeys[i])) {
      return false
    }

    for (const key of xKeys) {
      const xEl = (x as any)[key]
      const yEl = (y as any)[key]

      if (!deepEquals(xEl, yEl)) {
        return false
      }
    }

    return true
  } else if (x instanceof Date && y instanceof Date) {
    return x.getTime() === y.getTime()
  } else {
    return false
  }
}

export function keys<T extends Record<string, unknown>>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[]
}
